import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgHeart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 21 18"
    {...props}
  >
    <path
      d="M10.544 17.5c.984-.409 9.956-4.316 9.956-10.873 0-6.938-5.876-6.095-5.876-6.095S11.764.847 10.5 3.24C9.235.847 6.376.532 6.376.532S.5-.31.5 6.627c0 6.557 8.972 10.464 9.956 10.873h.088z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgHeart);
export default Memo;
